import ProfileTabsLoaderMobile from "./profileTabsLoaderMobile/ProfileTabsLoaderMobile";
import ProfileTabsLoaderWeb from "./profileTabsLoaderWeb/ProfileTabsLoaderWeb";

function ProfileTabsLoader(props) {
	if (props.isMobile) {
		return <ProfileTabsLoaderMobile />;
	} else {
		return <ProfileTabsLoaderWeb />;
	}
}

export default ProfileTabsLoader;
